import React, { useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../lib/constant";
import { fontFamily, product_sans, fontSize } from "../../lib/fonts";
import { IconCross20 } from "../../icons-ts";
import { motion, HTMLMotionProps } from "framer-motion";
import { mediaQuery } from "react-styled-mediaquery";

const Background = styled(motion.div)`
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalBox = styled(motion.div)`
  background: #fff;
  width: Calc(80% - 60px);
  max-width: 800px;
  border-radius: 20px;
  padding: 60px;
  position: relative;

  ${mediaQuery("<=", "phablet")`
    max-height: 70vh;
    overflow-y: scroll;
    padding: 30px;
  `}
`;

const CloseIcon = styled(IconCross20)`
  fill: ${colors.primary};
  width: 30px;
  height: 30px;
`;

const Close = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  transition: transform 0.2s;

  &:active {
    transform: scale(0.9);
  }
`;

const Module = styled.div`
  ${fontFamily(product_sans.bold)};
  ${fontSize("12px")};
  color: ${colors.secondary};
  margin-bottom: 15px;
`;

const animationModal: HTMLMotionProps<"div">["variants"] = {
  open: {
    visibility: "visible",
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
  closed: { opacity: 0, transitionEnd: { visibility: "hidden" } },
};

const item: HTMLMotionProps<"div">["variants"] = {
  open: { opacity: 1, y: 0, transition: { delay: 0.1, type: "spring" } },
  closed: { opacity: 0, y: 30 },
};

export const Modal = ({
  isOpen,
  onRequestClose,
  children,
  noSubTitle,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  noSubTitle?: boolean;
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.removeAttribute("style");
    }
  }, [isOpen]);

  return (
    <>
      <Background
        animate={isOpen ? "open" : "closed"}
        variants={animationModal}
        initial={"closed"}
      >
        <ModalBox variants={item}>
          <Close onClick={onRequestClose}>
            <CloseIcon />
          </Close>
          {!noSubTitle && <Module>Modules</Module>}
          {children}
        </ModalBox>
      </Background>
    </>
  );
};
